import React, { Fragment } from 'react'
import { path, cond, T, always } from 'ramda'
import { Paragraph, TrophyIcon } from '@pga/pga-component-library'
import { ButtonBlue, ButtonOutline, Text, FlexColumn } from '../RootStyles'
import { EventCard, RowWrapper, CardRow, ItemRow, DetailRowWrapper } from './styled'
import eventConfig from './config'
import { validateFieldExists } from './utils'
import { isDateAfterToday } from '../utils'

export const RenderColumns = ({ Item, hit }) => {
  const IconComponent = path(['0', 'Icon'])(Item)

  return (
    <DetailRowWrapper>
      <IconComponent />
      <CardRow>
        {Item.map(({ header, DetailComponent, field }, idx) => (
          hit[field]
            ? (
              <ItemRow key={idx} idx={idx}>
                <Text>{header}</Text>
                <FlexColumn>
                  <DetailComponent hit={hit} />
                </FlexColumn>
              </ItemRow>
            ) : null
        ))}
      </CardRow>
    </DetailRowWrapper>
  )
}

export const RenderRow = ({ Item, hit }) => (
  <div>
    <Text>{Item.header}</Text>
    <FlexColumn>
      <Item.DetailComponent hit={hit} />
    </FlexColumn>
  </div>
)

export const DetailRow = ({ item: Item, hit, idx, isMobile }) => {
  return (
    validateFieldExists(hit, Item)
      ? (
        <Fragment>
          <RowWrapper>
            {Item.Icon && <Item.Icon />}
            {
              Array.isArray(Item)
                ? <RenderColumns {...{ Item, hit }} />
                : <RenderRow {...{ Item, hit }} />
            }
          </RowWrapper>
          {(isMobile || eventConfig.length - 1 > idx) ? <hr /> : null}
        </Fragment>
      )
      : null
  )
}

export const RegButton = cond([
  [
    ({ hit }) => isDateAfterToday(hit.deadline_datetime) && hit.register_url,
    ({ hit }) => <ButtonBlue as='a' target='_blank' href={hit.register_url}>Register</ButtonBlue>
  ],
  [
    ({ hit }) => !hit.deadline_datetime && isDateAfterToday(hit.start_datetime),
    always(<ButtonBlue disabled>Registration Coming Soon</ButtonBlue>)
  ],
  [
    ({ hit }) => hit.results_url,
    ({ hit }) => <ButtonOutline outline as='a' target='_blank' href={hit.results_url}><TrophyIcon /> View Results</ButtonOutline>
  ],
  [T, always(<ButtonBlue disabled>Registration Closed</ButtonBlue>)]
])

const DetailCard = ({ hit, showHeaderImage, isMobile }) => (
  <Fragment>
    <EventCard hit={hit} showHeaderImage={showHeaderImage}>
      {!isMobile && <Paragraph size='lg' fw='bold'>Event Details</Paragraph>}
      <RegButton hit={hit} />
      <div className='mt-3'>
        {eventConfig.map((item, idx) => <DetailRow item={item} hit={hit} key={idx} idx={idx} isMobile={isMobile} />)}
      </div>
    </EventCard>
  </Fragment>
)
export default DetailCard
